export interface SoftwareFilesRecord {
  fileTypeId: string;
  partNumber: string;
  uploadedDate: string;
  userId: string;
  id: string;
}

export interface CommunicatorFilesRecord {
  fileTypeId: string;
  uploadedDate: string;
  userId: string;
  id: string;
}

export interface StandardParameterConfigRecord {
  fileTypeId: string;
  partNumber: string;
  uploadedDate: string;
  userId: string;
  id: string;
}
export interface VimsRtdsTableDataItem {
  id: string;
  generationType: string;
  vimsFileName: string;
  vimsSha1: string;
  fileName: string;
  isReboot: boolean;
  rtdsSha1: string;
  configId: string;
  isDefault: boolean;
  subscriptionName: string;
  updatedTS: string;
  updatedBy: string;
  vimsConfigId: string;
}

export interface LibraryManagementState {
  softwareFiles: SoftwareFilesRecord[];
  communicatorFiles: CommunicatorFilesRecord[];
  standardParameterConfig: StandardParameterConfigRecord[];
  vimsShaValue: string,
  rtdsShaValue: string,
  vimsRtdsTableData: Array<VimsRtdsTableDataItem>;
}

export enum LibraryManagementActionNames {
  SET_SOFTWARE_FILES = 'SET_SOFTWARE_FILES',
  SET_COMMUNICATOR_FILES = 'SET_COMMUNICATOR_FILES',
  SET_STANDARD_PARAMETER_CONFIG_FILES = 'SET_STANDARD_PARAMETER_CONFIG_FILES',
  SET_VIMS_FILE_EXISTS = 'SET_VIMS_FILE_EXISTS',
  SET_RTDS_FILE_EXISTS = 'SET_RTDS_FILE_EXISTS',
  SET_VIMS_RTDS_TABLE_DATA = 'SET_VIMS_RTDS_TABLE_DATA',
}

interface SetSoftwareFiles {
  type: typeof LibraryManagementActionNames.SET_SOFTWARE_FILES;
  payload: SoftwareFilesRecord[];
}

interface SetCommunicatorFiles {
  type: typeof LibraryManagementActionNames.SET_COMMUNICATOR_FILES;
  payload: CommunicatorFilesRecord[];
}

interface SetStandardParameterConfigFiles {
  type: typeof LibraryManagementActionNames.SET_STANDARD_PARAMETER_CONFIG_FILES;
  payload: StandardParameterConfigRecord[];
}

interface SetVimsFileExist {
  type: typeof LibraryManagementActionNames.SET_VIMS_FILE_EXISTS;
  payload: string;
}

interface SetVimsRtdsTableData {
  type: typeof LibraryManagementActionNames.SET_VIMS_RTDS_TABLE_DATA;
  payload: VimsRtdsTableDataItem[];
}

interface SetRtdsFileExist {
  type: typeof LibraryManagementActionNames.SET_RTDS_FILE_EXISTS;
  payload: string;
}

export type LibraryManagementActionTypes =
  | SetSoftwareFiles
  | SetCommunicatorFiles
  | SetStandardParameterConfigFiles
  | SetVimsFileExist
  | SetVimsRtdsTableData
  | SetRtdsFileExist;
